 // Composant client pour gérer l'interactivité

import { UiAdvancedSelect, UiButton } from "@/components/ui";
import { useToast } from "@/composables/toast";
import { Plus, Trash2 } from "lucide-react";
import { useState } from "react";

interface InfoLotsFormProps {
  cities: any[];
  onChange: (
    infosLot: {
      ville: string;
      nblots: number;
    }[]
  ) => void;
}

export default function InfoLotsForm({ onChange, cities }: InfoLotsFormProps) {
  // État initial basé sur votre tableau infosLot
  const [infosLot, setInfosLot] = useState([
    {
      ville: "",
      nblots: 1,
    },
  ]);

  const checkCityAlreadyChoose = (ville: string): boolean => {
    return infosLot.map((lot) => lot.ville).includes(ville);
  };

  // Gérer les changements dans les champs du formulaire
  const handleChange = (
    index: number,
    field: string,
    value: string | number
  ) => {
    if (field === "ville" && value && checkCityAlreadyChoose(`${value}`)) {
      useToast("Ville deja choisie", { variant: "error" });
      removeLot(index);
      return;
    }
    const updatedInfosLot = [...infosLot];
    updatedInfosLot[index] = { ...updatedInfosLot[index], [field]: value };
    setInfosLot(updatedInfosLot);
    onChange(updatedInfosLot);
  };

  // Ajouter un nouveau lot
  const addLot = () => {
    setInfosLot([...infosLot, { ville: "", nblots: 1 }]);
  };

  // Supprimer un lot
  const removeLot = (index: number) => {
    const updatedInfosLot = infosLot.filter((_, i) => i !== index);
    setInfosLot(updatedInfosLot);
    onChange(updatedInfosLot);
  };

  return (
    <div className="w-full">
      <label className="ui-form-label">Informations sur les lots</label>
      {infosLot.map((lot, index) => (
        <div
          className="border border-gray-200 p-1 px-2 rounded rounded-md mb-2"
          key={index}
        >
          <div className="flex items-end gap-4 ">
            <div className="w-full ">
              <UiAdvancedSelect
                className="w-full"
                label="Ville"
                name="villeLivraison"
                loading={false}
                placeholder="Choisissez une ville"
                options={cities.map((ville) => ({
                  value: ville,
                  label: ville,
                }))}
                onChange={(v) => handleChange(index, "ville", v ?? "")}
              ></UiAdvancedSelect>
            </div>
            <div className="">
              <label className="ui-form-label">Nombre de lots</label>
              <input
                type="number"
                value={lot.nblots}
                onChange={(e) =>
                  handleChange(
                    index,
                    "nblots",
                    e.target.value ? parseInt(e.target.value) : 1
                  )
                }
                className="mt-1 p-2 border rounded w-full"
                min="1"
                placeholder="Entrez le nombre de lots"
              />
            </div>
            {infosLot.length > 1 && (
              <UiButton
                color="error"
                onClick={() => removeLot(index)}
                className="text-white-500 hover:text-white-700"
              >
                <Trash2 />
              </UiButton>
            )}
          </div>
        </div>
      ))}
      <UiButton
        color="primary"
        onClick={addLot}
        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 mt-4"
      >
        <Plus /> Ajouter un lot
      </UiButton>
    </div>
  );
}
